<template>
  <div style="width: 300px; height: 380px; margin: 0;">
    <!--    <iframe v-if="isusersession=='nosession'" id="pluginonlin" name="pluginonlin"-->
    <!--           :src="`https://tool.5118.com/Pluginonline`"-->
    <!--           style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->
    <!--    <iframe v-if="isuseruserinfo=='nosession'" id="pluginonlin" name="pluginonlin"-->
    <!--           :src="`https://tool.5118.com/Pluginonline`"-->
    <!--           style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->
    <!-- <iframe v-if="logged" id="onlinetongji" name="onlinetongji"
           :src="`https://aiplugin.5118.com/Pluginstat/?p=UserOnline`"
           style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe> -->
    <ul
      style="
        width: 100%;
        display: table;
        margin: 0;
        border-bottom: 1px solid #166df1;
      "
    >
      <li
        style="width: 35%; text-align: left; margin-left: 2%; margin-bottom: 0;"
      >
        <img
          id="main_log_ico"
          style="height: 40px; vertical-align: middle;"
          src="../assets/image/logo.png"
          v-if="version < 999 && version"
        />
        <img
          id="main_log_ico"
          style="height: 40px; vertical-align: middle;"
          src="../assets/image/logoAi.png"
          v-if="version == 999"
        />
      </li>
      <li style="width: 32%; text-align: center; margin: 0;">
        <h3
          v-if="version"
          style="
            margin: 0;
            line-height: 40px;
            vertical-align: 5px;
            color: #166df1;
            text-align: left;
          "
        >
          {{ version == 999 ? '5118AI助手' : '站长工具箱' }}
        </h3>
      </li>
      <li
        style="
          width: 28%;
          text-align: right;
          line-height: 40px;
          margin-bottom: 0;
        "
      >
        <div class="user-box" :class="{ logged }" @click="showLogin">
          <img
            :src="userInfo.avatar || require(`../assets/image/user/user.png`)"
            class="head-img"
            :onerror="`this.src='${require(`../assets/image/user/user.png`)}'`"
          />
          <ul>
            <li>
              <a
                href="https://account.5118.com/signin/invitation "
                target="_blank"
                >个人中心</a
              >
            </li>
            <li>
              <a href="https://account.5118.com/signin/logout" target="_blank"
                >退出</a
              >
            </li>
          </ul>
        </div>

        <div style="display: inline-block;">
          <v-switch v-model="plugin_isopen" style="z-index: 10;"></v-switch>
        </div>
      </li>
    </ul>
    <div style="margin: 0 10px;">
      <div id="RightID" v-if="version > 200 && version < 999">
        <ul style="width: 100%; margin: 15px 0px;">
          <li style="width: 70%;">
            <img
              src="../assets/image/Right_ico.png"
              style="vertical-align: middle; margin-right: 10px;"
            />显示右侧面板
          </li>
          <li style="width: 30%; text-align: right;">
            <div>
              <v-switch
                v-model="rightlistswitch"
                style="z-index: 10;"
              ></v-switch>
            </div>
          </li>
        </ul>
      </div>
      <h3 v-if="version < 999" style="color: #aaaaaa; margin: 15px 0;">
        功能增强
      </h3>

      <div id="NewID" style="margin-top: 15px;">
        <!--
        <ul style="width:100%;">
          <li style="width:70%;"><img src="../assets/image/ad_ico.png"
                                      style="vertical-align: middle;margin-right: 10px">隐藏百度搜索广告
          </li>
          <li style="width:30%;text-align: right">
            <div>
              <v-switch v-model="onclosebaidu" style="z-index:10;"></v-switch>
            </div>
          </li>
        </ul> -->

        <!-- <ul style="width:100%;" v-if="version>200 && version<999">
          <li style="width:70%;"><img src="../assets/image/showrank_ico.png"
                                      style="vertical-align: middle;margin-right: 10px">显示百度排名号码
          </li>
          <li style="width:30%;text-align: right">
            <div>
              <v-switch v-model="baidurankswitch" style="z-index:10;"></v-switch>
            </div>
          </li>
        </ul> -->

        <!-- <ul v-if="version > 200" style="width:100%;">
          <li style="width:70%;"><img src="../assets/image/seodata.png"
                                      style="vertical-align: middle;margin-right: 10px">百度SEO优化难度
          </li>
          <li style="width:30%;text-align: right">
            <div>
              <v-switch v-model="baiduseodataswitch" style="z-index:10;"></v-switch>
            </div>
          </li>
        </ul> -->

        <!-- <ul v-if="version > 200" style="width:100%;">
          <li style="width:70%;"><img src="../assets/image/icp.png"
                                      style="vertical-align: middle;margin-right: 10px">百度备案数据显示
          </li>
          <li style="width:30%;text-align: right">
            <div>
              <v-switch v-model="baiduicpdataswitch" style="z-index:10;"></v-switch>
            </div>
          </li>
        </ul> -->
        <!--
        <ul style="width:100%;" v-if="version>200 && version<999">
          <li style="width:70%;" title="强力破解网页结构，请在需要的页面打开此功能"><img src="../assets/image/copy_ico.png"
                                                                    style="vertical-align: middle;margin-right: 10px">解锁文字复制限制(谨慎打开)
          </li>
          <li style="width:30%;text-align: right">
            <div>
              <div>
                <v-switch v-model="pagecopyswitch" style="z-index:10;"></v-switch>
              </div>
            </div>
          </li>
        </ul> -->

        <ul v-if="version <= 999" style="width: 100%;">
          <li style="width: 70%;">
            <img
              src="../assets/image/wyc_ico.png"
              style="vertical-align: middle; margin-right: 10px;"
            />划取页面句子原创
          </li>
          <li style="width: 30%; text-align: right;">
            <div>
              <div>
                <v-switch
                  v-model="poriginalswitch"
                  style="z-index: 10;"
                ></v-switch>
              </div>
            </div>
          </li>
        </ul>
        <ul v-if="version <= 999" style="width: 100%;">
          <li style="width: 70%;">
            <img
              src="../assets/image/edit_popup_ico.png"
              style="vertical-align: middle; margin-right: 10px;"
            />智能原创编辑器增强
            <a
              href="https://www.5118.com/act/wyc_editor_enhance"
              target="_blank"
            >
              <span style="color: #166df2; text-decoration: underline;"
                >(查看介绍)</span
              ><img
                style="position: absolute; margin-top: -5px;"
                src="../assets/image/new_ico.png"
            /></a>
          </li>
          <li style="width: 30%; text-align: right;">
            <div>
              <v-switch v-model="cmseditswitch" style="z-index: 10;"></v-switch>
            </div>
          </li>
        </ul>
      </div>
      <!-- <br v-if="version < 201 || version==''"> -->
      <br />
      <div
        style="
          width: 100%;
          height: 1px;
          border-bottom: 1px dashed #ccc;
          box-sizing: border-box;
        "
      ></div>
      <ul style="width: 100%;" class="linkul">
        <li class="linkli">
          <a href="https://ci.5118.com/?f=plugin" target="_blank">挖长尾词</a>
        </li>
        <li class="linkli">
          <a href="https://www.5118.com/traffic?f=plugin" target="_blank"
            >挖流量词</a
          >
        </li>
        <li class="linkli">
          <a
            href="https://www.5118.com/seo/search/related?f=plugin"
            target="_blank"
            >挖相关词</a
          >
        </li>
        <li class="linkli" style="width: 28%;" v-if="version < 999 && version">
          <a
            href="https://tool.5118.com/download#tab-card"
            style="color: darkorange; text-decoration: underline;"
            target="_blank"
            >插件常见问题</a
          >
        </li>
        <li class="linkli" v-if="version == 999">
          <a
            href="https://www.5118.com/ai/autoexpander?f=plugin"
            target="_blank"
            >文本扩写</a
          >
        </li>
      </ul>
      <ul style="width: 100%;" v-if="version == 999" class="linkul">
        <li class="linkli" style="width: 34%;">
          <a
            href="https://www.5118.com/ai/articlegenius?f=plugin"
            target="_blank"
            >一键式文章助手</a
          >
        </li>
        <li class="linkli" style="width: 30%;">
          <a href="https://www.5118.com/ai/besttitle?f=plugin" target="_blank"
            >吸睛标题助手</a
          >
        </li>
        <li class="linkli">
          <a href="https://www.5118.com/tutorials#page-qita" target="_blank"
            ><span style="color: #166df2; text-decoration: underline;"
              >查看更多</span
            ></a
          >
        </li>
      </ul>
    </div>
    <Loading2 v-if="!logged" :version="version"></Loading2>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import Loading2 from '../components/global/LoginBox2/Main';
// import axios  from 'axios'
export default {
  name: 'PopUp',
  watch: {
    plugin_isopen(newVal) {
      if (!newVal) {
        this.rightlistswitch = false;
        this.onclosebaidu = false;
        this.baidurankswitch = false;
        this.baiduseodataswitch = false;
        this.baiduicpdataswitch = false;
        this.pagecopyswitch = false;
        this.poriginalswitch = false;
        this.cmseditswitch = false;
      }

      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send(
        'Plugin-5118-Open-Close',
        newVal ? 1 : 2
      );
    },
    rightlistswitch(newVal) {
      if (newVal) {
        this.plugin_isopen = true;
      }
      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send(
        'Plugin-5118-Right-List',
        newVal ? 1 : 2
      );
    },
    onclosebaidu(newVal) {
      if (newVal) {
        this.plugin_isopen = true;
      }
      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send(
        'Plugin-5118-Baidu-AD',
        newVal ? 1 : 2
      );
    },
    baidurankswitch(newVal) {
      if (newVal) {
        this.plugin_isopen = true;
      }
      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send(
        'Plugin-5118-Baidu-Rank',
        newVal ? 1 : 2
      );
    },
    baiduseodataswitch(newVal) {
      if (newVal) {
        this.plugin_isopen = true;
      }
      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send(
        'Plugin-5118-BaiduSeo-Data',
        newVal ? 1 : 2
      );
    },
    baiduicpdataswitch(newVal) {
      if (newVal) {
        this.plugin_isopen = true;
      }
      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send(
        'Plugin-5118-BaiduIcp-Data',
        newVal ? 1 : 2
      );
    },
    pagecopyswitch(newVal) {
      if (newVal) {
        this.plugin_isopen = true;
      }
      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send(
        'Plugin-5118-Page-Copy',
        newVal ? 1 : 2
      );
    },
    poriginalswitch(newVal) {
      if (newVal) {
        this.plugin_isopen = true;
      }
      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send(
        'Plugin-5118-Pseudo-Original',
        newVal ? 1 : 2
      );
    },
    cmseditswitch(newVal) {
      if (newVal) {
        this.plugin_isopen = true;
      }
      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send(
        'Plugin-5118-Cms-Edit-Pseudo-Original',
        newVal ? 1 : 2
      );
    },
  },
  data() {
    return {
      loginBox: null,
      isusersession: '',
      isuseruserinfo: '',
    };
  },
  components: {
    Loading2,
  },
  computed: {
    plugin_isopen: {
      get() {
        return this.$store.state.popup.pluginswitch;
      },
      set(val) {
        this.$store.state.popup.pluginswitch = val;
      },
    },
    rightlistswitch: {
      get() {
        return this.$store.state.popup.rightlistswitch;
      },
      set(val) {
        this.$store.state.popup.rightlistswitch = val;
      },
    },
    onclosebaidu: {
      get() {
        return this.$store.state.popup.baiduadswitch;
      },
      set(val) {
        this.$store.state.popup.baiduadswitch = val;
      },
    },
    baidurankswitch: {
      get() {
        return this.$store.state.popup.baidurankswitch;
      },
      set(val) {
        this.$store.state.popup.baidurankswitch = val;
      },
    },
    baiduseodataswitch: {
      get() {
        return this.$store.state.popup.baiduseodataswitch;
      },
      set(val) {
        this.$store.state.popup.baiduseodataswitch = val;
      },
    },
    baiduicpdataswitch: {
      get() {
        return this.$store.state.popup.baiduicpdataswitch;
      },
      set(val) {
        this.$store.state.popup.baiduicpdataswitch = val;
      },
    },
    pagecopyswitch: {
      get() {
        return this.$store.state.popup.pagecopyswitch;
      },
      set(val) {
        this.$store.state.popup.pagecopyswitch = val;
      },
    },
    poriginalswitch: {
      get() {
        return this.$store.state.popup.poriginalswitch;
      },
      set(val) {
        this.$store.state.popup.poriginalswitch = val;
      },
    },
    version: {
      get() {
        return this.$store.state.popup.version;
      },
      set(val) {
        this.$store.state.popup.version = val;
      },
    },
    logged: {
      get() {
        return this.$store.state.user.logged;
      },
      set(val) {
        this.$store.state.user.logged = val;
      },
    },
    userInfo: {
      get() {
        return this.$store.state.user.userInfo;
      },
      set(val) {
        this.$store.state.user.userInfo = val;
      },
    },
    cmseditswitch: {
      get() {
        return this.$store.state.popup.cmseditswitch;
      },
      set(val) {
        this.$store.state.popup.cmseditswitch = val;
      },
    },
  },
  mounted() {
    this.get_user_data();
    this.listenPopupinfo();
    this.get_userinfo_coookies();
    // this.sendStatelist();
  },
  methods: {
    listenPopupinfo() {
      this.$messengernew.listen('_5118_Isok', (msg) => {
        this.sendStatelist();
      });

      this.$messengernew.listen('_5118_Plugin_Open_Close', (msg) => {
        if (msg === 1) {
          this.plugin_isopen = true;
        } else {
          this.plugin_isopen = false;
        }
        // msg == 1 ? this.plugin_isopen = true : this.plugin_isopen = false
      });
      this.$messengernew.listen(
        '_5118_Plugin_Cms_Edit_Pseudo_Original',
        (msg) => {
          msg == 1 ? (this.cmseditswitch = true) : (this.cmseditswitch = false);
        }
      );
      this.$messengernew.listen('_5118_Plugin_Baidu_AD', (msg) => {
        msg == 1
          ? (this.$store.state.popup.baiduadswitch = true)
          : (this.$store.state.popup.baiduadswitch = false);
      });
      this.$messengernew.listen('_5118_Plugin_Baidu_Rank', (msg) => {
        msg == 1
          ? (this.$store.state.popup.baidurankswitch = true)
          : (this.$store.state.popup.baidurankswitch = false);
      });
      this.$messengernew.listen('_5118_Plugin_BaiduSeo_Data', (msg) => {
        msg == 1
          ? (this.$store.state.popup.baiduseodataswitch = true)
          : (this.$store.state.popup.baiduseodataswitch = false);
      });
      this.$messengernew.listen('_5118_Plugin_BaiduIcp_Data', (msg) => {
        msg == 1
          ? (this.$store.state.popup.baiduicpdataswitch = true)
          : (this.$store.state.popup.baiduicpdataswitch = false);
      });
      this.$messengernew.listen('_5118_Plugin_Page_Copy', (msg) => {
        msg == 1
          ? (this.$store.state.popup.pagecopyswitch = true)
          : (this.$store.state.popup.pagecopyswitch = false);
      });
      this.$messengernew.listen('_5118_Plugin_Pseudo_Original', (msg) => {
        msg == 1
          ? (this.poriginalswitch = true)
          : (this.poriginalswitch = false);
      });
      this.$messengernew.listen('_5118_Plugin_Right_List', (msg) => {
        msg == 1
          ? (this.rightlistswitch = true)
          : (this.rightlistswitch = false);
      });
      this.$messengernew.listen('_5118_PopUp_Version_No', (msg) => {
        this.version = msg.replace(/\./gi, '');
        // console.log(this.version);
      });
      this.$messengernew.listen('_5118_Show_Main_Login', (msg) => {
        if (this.logged) {
          return;
        }
        if (this.loginBox) {
          this.loginBox.close();
          this.loginBox = null;
        }
        this.loginBox = this.$loginBox2();
      });
    },
    sendStatelist() {
      this.$messengernew.addTarget(window.parent, 'parent');
      this.$messengernew.targets['parent'].send('Plugin-5118-Popup-State');
    },
    get_userinfo_coookies() {
      let userInfo =
        JSON.parse(Cookies.get('_5118_Plug_In_UserInfo') || '{}') || {};
      this.logged = !!userInfo.avatar;
      this.userInfo = userInfo;
      if (this.isusersession != 'nosession')
        this.isuseruserinfo = userInfo.uid || 'nosession';
    },
    showLogin() {
      if (!this.logged) {
        if (this.loginBox) {
          this.loginBox.close();
          this.loginBox = null;
        }
        this.loginBox = this.$loginBox2();
      }
    },
    get_user_data() {
      this.isusersession = Cookies.get('_5118_Plug_In_Session') || 'nosession';
    },
  },
};
</script>

<style type="text/less" lang="less" scoped>
@import '../assets/style/color';
@import '../assets/style/config';
@import '../assets/style/mixin';
.linkul {
  .linkli {
    line-height: 15px !important;
    width: 23.333%;
    text-align: center;
  }
}
.user-box {
  display: inline-block;
  margin-right: 7px;
  position: relative;
  .head-img {
    vertical-align: -5px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    cursor: pointer;
  }
  ul {
    z-index: 999;
    padding: 0;
    position: absolute;
    background-color: white;
    box-shadow: #eaeaea 0 1px 6px 0;
    left: -35px;
    width: 95px;
    display: none;
    top: 35px;
    li {
      list-style: none;
      display: block;
      width: 100%;
      a {
        display: block;
        color: #999;
        padding: 0 15px;
        line-height: 35px;
        font-size: 14px;
        &:hover {
          background-color: #ebf5ff;
        }
      }
    }
  }
  &.logged {
    &:hover {
      ul {
        display: block;
      }
    }
  }
}
</style>

<style>
/* body {
      width: 320px;
      min-height: 100px;
      margin: 0;
  } */

a {
  color: #666;
  text-decoration: none;
}

a:hover {
  color: #2d7dff;
}

ul {
  display: table;
  width: 100%;
  padding: 0;
  margin: 5px 0;
}

ul li {
  list-style: none;
  margin-bottom: 4px;
  float: left; /* 往左浮动 */
  text-align: left;
  line-height: 22px;
  font-family: 'Lato', sans-serif;
  font-size: 10px;
}

li {
  list-style: none;
  margin-bottom: 4px;
  float: left; /* 往左浮动 */
  text-align: center;
  line-height: 30px;
  font-family: 'Lato', sans-serif;
  font-size: 10px;
}

.switch-input {
  display: none;
}

.switch-input:checked + .switch {
  background-color: #d5e5ff;
}

.switch-input:checked + .switch span {
  right: 0;
  left: auto;
  background-color: #2d7dff;
}

.switch {
  cursor: pointer;
  display: inline-block;
  width: 25px;
  background-color: #ccc;
  height: 12px;
  vertical-align: -1px;
  border-radius: 15px;
  position: relative;
}

.switch span {
  display: inline-block;
  height: 14px;
  width: 14px;
  left: 0;
  position: absolute;
  background-color: #888;
  top: -1px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/PopUp.vue